<template>
  <v-container>
    <v-row dense>
      <v-col cols="12">
        <v-card width="100%" class="text-center mb-5" elevation="0">
          <v-btn href="skype:overinet?chat" icon color="#009ae4">
            <v-icon x-large>mdi-skype-business</v-icon>
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
};
</script>


<style scoped>
</style>